/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import Completed from './Completed/index'
import Created from './Created/index'
import Error from './Error/index'
import No from './No/index'
import Processed from './Processed/index'
import Processing from './Processing/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/Actions/Content/SyncAction/Content/LastSyncStatus/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let syncStatusValueData = fromData.useDataFormat({ viewPath,
context: 'sync',
path: 'status',
format: fromFormat.capitalize,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: syncStatusValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Processing'}>
<Processing
  viewPath={`${viewPath}/Processing`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Processed'}>
<Processed
  viewPath={`${viewPath}/Processed`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Completed'}>
<Completed
  viewPath={`${viewPath}/Completed`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Error'}>
<Error
  viewPath={`${viewPath}/Error`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Created'}>
<Created
  viewPath={`${viewPath}/Created`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}